import Vue from "vue";
import Vuex from "vuex";
import { $preferences } from "@core/services/";
Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    associatedField: {
      groups: {},
      types: {},
      channelList: [],
      priorities: [],
      statusList: [],
      agentList: [],
      tagList: [],
    },
    filterData: {
      status: [],
      priority: [],
      channel: [],
      type: [],
      group: [],
      selectedAgent: [],
      dates: [],
      selectedContact: [],
      tags: [],
    },
    appliedFilter: {},
    listOfComments: [],
    savedFilterId: null,
    selectedFilterId: null,
    filterAccountId: null,
    filterMode: '',
    all: {
      appliedFilter: {},
      filterData: {
        status: [],
        priority: [],
        channel: [],
        type: [],
        group: [],
        selectedAgent: [],
        dates: [],
        selectedContact: [],
        tags: [],
      },
    },
  },

  mutations: {
    associatedField: (state, data) => {
      state.associatedField = data;
    },
    groups: (state, data) => {
      state.associatedField.groups = data;
    },
    types: (state, data) => {
      state.associatedField.types = data;
    },
    priorities: (state, data) => {
      state.associatedField.priorities = data;
    },
    statusList: (state, data) => {
      state.associatedField.statusList = data;
    },
    agentList: (state, data) => {
      state.associatedField.agentList = data;
    },
    tagList: (state, data) => {
      state.associatedField.tagList = data;
    },
    channelList: (state, data) => {
      state.associatedField.channelList = data;
    },
    filterData: (state, data) => {
      if(state.savedFilterId){
        state.filterData = data;
      }else{
        state.all.filterData = data;
      }
    },
    appliedFilter: (state, data) => {
      if(state.savedFilterId){
        state.appliedFilter = data;
      }else{
        state.all.appliedFilter = data;
      }
    },
    listOfComments: (state, data) => {
      state.listOfComments = data;
    },
    savedFilterId: (state, data) => {
      state.savedFilterId = data;
    },
    selectedFilterId: (state, data) => {
      state.selectedFilterId = data;
    },
    filterMode: (state, data) => {
      state.filterMode = data;
    },
    filterAccountId: (state, data) => {
      state.filterAccountId = data;
    },
  },
  actions: {
    associatedField({ commit }, [data]) {
      commit("associatedField", data);
    },
    groups({ commit }, [data]) {
      commit("groups", data);
    },
    types({ commit }, [data]) {
      commit("types", data);
    },
    priorities({ commit }, [data]) {
      commit("priorities", data);
    },
    statusList({ commit }, [data]) {
      commit("statusList", data);
    },
    agentList({ commit }, [data]) {
      commit("agentList", data);
    },
    tagList({ commit }, [data]) {
      commit("tagList", data);
    },
    channelList({ commit }, [data]) {
      commit("channelList", data);
    },
    filterData({ commit }, [data]) {
      commit("filterData", data);
    },
    appliedFilter({ commit }, [data]) {
      commit("appliedFilter", data);
    },

    listOfComments({ commit }, [data]) {
      commit("listOfComments", data);
    },
    savedFilterId({ commit }, data) {
      commit("savedFilterId", data);
    },
    selectedFilterId({ commit }, data) {
      commit("selectedFilterId", data);
    },
    filterMode({ commit }, data) {
      commit("filterMode", data);
    },
    filterAccountId({ commit }, data) {
      commit("filterAccountId", data);
    },
  },
  getters: {
    associatedField: (state) => state.associatedField,
    groups: (state) => state.associatedField.groups,
    types: (state) => state.associatedField.types,
    priorities: (state) => state.associatedField.priorities,
    statusList: (state) => state.associatedField.statusList,
    agentList: (state) => state.associatedField.agentList,
    tagList: (state) => state.associatedField.tagList,
    channelList: (state) => state.associatedField.channelList,
    filterData: (state) => state.savedFilterId ? state.filterData: state.all.filterData,
    appliedFilter: (state) => state.savedFilterId ? state.appliedFilter : state.all.appliedFilter,
    listOfComments: (state) => state.listOfComments,
    savedFilterId: (state) => state.savedFilterId,
    selectedFilterId: (state) => state.selectedFilterId,
    filterMode: (state) => state.filterMode,
    filterAccountId: (state) => state.filterAccountId,
  },
};
